import type { CropVarietyConfigurationsByKey } from "../types.js";

export const citrusVarietyConfigurations = {
    "citrus.bearss": {
        crop: "citrus",
        aliases: [
            "Persian",
            "Tahiti",
            "Persian Lime",
            "Tahiti Lime",
            "Bearss Lime",
            "Limón Persa",
            "Limão Tahiti",
            "Lima Tahiti",
            "Lime de Tahiti",
        ],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.chandler": {
        crop: "citrus",
        aliases: ["Chandler Pummelo"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.clementine": {
        crop: "citrus",
        aliases: ["Clementina"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Clemenules", "Fina", "Hernandina", "Marisol", "Oroval"],
    },
    "citrus.daisy": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.eureka": {
        crop: "citrus",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Allen", "Frost"],
    },
    "citrus.fairchild": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.fino": {
        crop: "citrus",
        aliases: ["Primofiori", "Mesero"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.genova": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.gold-nugget": {
        crop: "citrus",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.hamlin": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.kinnow": {
        crop: "citrus",
        aliases: ["Kinno"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.kishu": {
        crop: "citrus",
        aliases: ["Kishu Mikan"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.lisbon": {
        crop: "citrus",
        aliases: [],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Frost", "Limoneira 8A"],
    },
    "citrus.marsh": {
        crop: "citrus",
        aliases: ["Marsh Seedless", "Marsh White"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.mexican-lime": {
        crop: "citrus",
        aliases: [
            "Key Lime",
            "West Indian Lime",
            "Limón Mexicano",
            "Limón Criollo",
            "Limón Agrio",
            "Limón Sutil",
            "Limão Galego",
            "Lima Mexicana",
            "Lime mexicaine",
            "Kagzi Lime",
        ],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.meyer": {
        crop: "citrus",
        aliases: ["Meyer Lemon", "Improved Meyer"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.minneola": {
        crop: "citrus",
        aliases: ["Honeybell", "Mineola", "Minneola Tangelo"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.moro": {
        crop: "citrus",
        aliases: ["Moro Blood Orange"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.murcott": {
        crop: "citrus",
        aliases: ["Honey Tangerine", "Murcote"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.natal": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.navel": {
        crop: "citrus",
        aliases: ["Washington Navel", "Bahia", "Baía"],
        isExample: false,
        customName: false,
        knownClonalSelections: [
            "Atwood",
            "Barnfield",
            "Cara Cara",
            "Fisher",
            "Fukumoto",
            "Lane Late",
            "Navelate",
            "Navelina",
            "Newhall",
            "Powell",
        ],
    },
    "citrus.nova": {
        crop: "citrus",
        aliases: ["Clemenvilla"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.oro-blanco": {
        crop: "citrus",
        aliases: ["Sweetie"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.orri": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.page": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.pera": {
        crop: "citrus",
        aliases: ["Pera Rio"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.pixie": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.ponkan": {
        crop: "citrus",
        aliases: ["Poncã"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.rio-red": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.ruby-red": {
        crop: "citrus",
        aliases: ["Redblush"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.satsuma": {
        crop: "citrus",
        aliases: ["Unshu", "Mikan", "Owari", "Unshiu", "Satsuma Mandarin"],
        isExample: false,
        customName: false,
        knownClonalSelections: ["Okitsu", "Owari"],
    },
    "citrus.shasta-gold": {
        crop: "citrus",
        aliases: ["TDE2"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.shiranui": {
        crop: "citrus",
        aliases: ["Dekopon", "Sumo", "Sumo Citrus", "Hallabong"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.star-ruby": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.tango": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.tarocco": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.valencia": {
        crop: "citrus",
        aliases: ["Valencia Late"],
        isExample: true,
        customName: false,
        knownClonalSelections: ["Campbell", "Cutter", "Delta", "Midknight", "Olinda"],
    },
    "citrus.verna": { crop: "citrus", aliases: [], isExample: false, customName: false, knownClonalSelections: [] },
    "citrus.w-murcott": {
        crop: "citrus",
        aliases: ["Nadorcott", "Afourer"],
        isExample: false,
        customName: false,
        knownClonalSelections: [],
    },
    "citrus.custom": { crop: "citrus", aliases: [], isExample: false, customName: true, knownClonalSelections: [] },
} as const satisfies CropVarietyConfigurationsByKey;
